import { Component } from '@angular/core';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { NewAccountType } from 'common';

@Component({
  selector: 'acc-registration-account-type',
  templateUrl: './account-type.component.html',
  styleUrl: './account-type.component.scss',
})
export class AccountTypeComponent {
  get formGroupAccountType() {
    return this.accountRegistrationService.formGroupAccountType;
  }

  NewAccountType = NewAccountType;

  constructor(private readonly accountRegistrationService: AccountRegistrationService) {}

  onAccountTypeChange(value: NewAccountType) {
    this.accountRegistrationService.setAccountType(value);
  }
}
